import { supabase } from './supabase'

export const createDemoUser = async () => {
  try {
    console.log('🔧 Creating demo user...')
    
    // First, try to sign up the demo user
    const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
      email: 'demo@mentra.com',
      password: 'demo123456',
      options: {
        data: {
          role: 'HR',
          company_name: 'Mentra Demo Company'
        }
      }
    })

    if (signUpError) {
      // If user already exists, that's fine
      if (signUpError.message.includes('already registered')) {
        console.log('✅ Demo user already exists')
        return { success: true, message: 'Demo user already exists' }
      }
      console.error('❌ Error creating demo user:', signUpError)
      return { success: false, error: signUpError }
    }

    if (signUpData.user) {
      console.log('✅ Demo user created:', signUpData.user.id)
      
      // Create user record in users table
      const { error: userError } = await supabase
        .from('users')
        .upsert({
          id: signUpData.user.id,
          email: 'demo@mentra.com',
          role: 'HR',
          company_id: '00000000-0000-0000-0000-000000000001',
          status: 'active'
        })

      if (userError) {
        console.error('❌ Error creating user record:', userError)
        return { success: false, error: userError }
      }

      // Link employee record to user
      const { error: employeeError } = await supabase
        .from('employees')
        .update({ user_id: signUpData.user.id })
        .eq('id', '00000000-0000-0000-0000-000000000002')

      if (employeeError) {
        console.error('❌ Error linking employee record:', employeeError)
        return { success: false, error: employeeError }
      }

      console.log('✅ Demo user setup complete')
      return { success: true, user: signUpData.user }
    }

    return { success: false, error: 'No user returned from signup' }
  } catch (error) {
    console.error('❌ Exception creating demo user:', error)
    return { success: false, error }
  }
}

export const ensureDemoUserExists = async () => {
  try {
    // Try to sign in with demo credentials first
    const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
      email: 'demo@mentra.com',
      password: 'demo123456'
    })

    if (!signInError && signInData.user) {
      console.log('✅ Demo user exists and can sign in')
      // Sign out immediately since we're just checking
      await supabase.auth.signOut()
      return { exists: true }
    }

    // If sign in failed, try to create the user
    if (signInError?.message.includes('Invalid login credentials')) {
      console.log('🔧 Demo user does not exist, creating...')
      const result = await createDemoUser()
      return { exists: result.success, created: result.success }
    }

    return { exists: false, error: signInError }
  } catch (error) {
    console.error('❌ Error checking demo user:', error)
    return { exists: false, error }
  }
}